<template>
  <modal-component
    label="Detalle documentación"
    button-label="Cerrar"
    @close="onClose"
    @aceptar="onClose"
  >
    <p class="primera">
      Cuando llegue el correo al domicilio que elegiste te vamos a pedir:
    </p>
    <div class="items">
      <ul class="verde">
        <li>
          Que este la persona que solicito la tarjeta (el / la que será
          <strong>títular de la tarjeta</strong>).
        </li>
        <li>
          Fotocopia del <strong>DNI</strong>, frente y dorso (sólo es válido el
          "Nuevo DNI" o "DNI Tarjeta").
        </li>
        <li>
          Fotocopia de <strong>un servicio</strong> a tu nombre donde, figure tu
          domicilio particular.
        </li>
        <li class="no-disc">
          Los servicios válidos son:
          <strong>Celular, Gas, Luz, Agua, Rentas</strong> (no patente).
        </li>
        <li class="no-disc">
          Si no tenés ninguno de estos servicios a tu nombre podés presentar:
        </li>
        <ul class="gris">
          <li>
            Opción 1: Otro servicio a tu nombre ( Cable o Internet ), más un
            servicio a nombre de otra persona donde figure el mismo domicilio en
            ambas.
          </li>
          <li>
            Opción 2: Un servicio a nombre de otra persona donde figure el
            domicilio que nos informaste, más una constacia del vínculo con esa
            persona. Por ejemplo, copia del contrato de alquiler.
          </li>
        </ul>
      </ul>
    </div>
  </modal-component>
</template>

<script>
import ModalComponent from "@/components/core/ModalComponent";
export default {
  name: "DocumentationDetail",
  components: {
    "modal-component": ModalComponent
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
p.primera {
  margin-bottom: 13px;
  color: black;
}

div.items {
  color: #666666;
}

ul {
  white-space: normal;
}

ul.verde > li {
  margin-bottom: 10px;
}

ul.gris > li {
  margin-bottom: 20px;
}
</style>
